import React, { useRef } from "react";
import { Route, Navigate, useNavigate, Routes } from "react-router-dom";
import { withTranslation } from "react-i18next";
import IdleTimer from "react-idle-timer";
import PageNotFound from "../../../shared/components/PageNotFound.jsx";
import Layout from "../../Layout/topbar/index.jsx";
import Footer from "../../Layout/footer/footer.jsx";
import PrivacyNotice from "../PrivacyNotice";
import PersonalInformation from "../PersonalInformation";
import ReviewSummary from "../ReviewSummary";
import Confirmation from "../Confirmation";
import NotEligible from "../NotEligible";
import CancelConfirmation from "../../../shared/components/CancelConfirmation.jsx";

//HARP
import HARPIncome from "../HARPIncome";
import HARPQualify from "../HARPQualify";
import AgeCheck from "../HARPAgeCheck/index.jsx";
import HeatingLetterFromSNS from "../HeatingLetterFromSNS";

import PayOwnHeatView from "../PayOwnHeatView/index.jsx";
import CDSAssistanceQ from "../CDSAssistanceQ/index.jsx";
import HeatingHomeWay from "../HeatingHomeWay/index.jsx";
import HeatingBillOpportunity from "../HeatingBillOpportunity/index.jsx";
import GuaranteedIncomeSuppliment from "../GuaranteedIncomeSuppliment/index.jsx";
import StartHarpPage from "../StartHarpPage";
import HARPLivingArrangement from "../HeatingHomeWay/index.jsx";

import HeatingBillProofNotNeeded from "../HeatingBillProofNotNeeded/index.jsx";
import ConsentToShareInformation from "../ConsentToShareInformation/index.jsx";
import CheckStatus from "../CheckStatus/index.jsx";
import ApplicationStatus from "../ApplicationStatus/index.jsx";
import UploadHeatingBill from "../UploadHeatingBill/index.jsx";
import HouseholdTypeHARP from "../HouseholdTypeHARP/index.jsx";
import ApplicantSituationChange from "../ApplicantSituationChange/index.jsx";
import HeatingBillQuestion from "../HeatingBillQuestion/index.jsx";
import OtherAdultsLiving from "../OtherAdultsLiving/index.jsx";
import IncomeCheck from "../HARPIncome/components/IncomeCheck.jsx";
import HARPStepsMessages from "../HARPStepsMessages/index.jsx";
import WithoutUploadingHeatingProof from "../WithoutUploadingHeatingProof/index.jsx";
import OtherAdultsForm from "../OtherAdultsForm/index.jsx";

const OnlineBookingRoutes = ({ t, i18n }) => {
  const navigate = useNavigate();
  const idleMinutes = process.env.REACT_APP_IDLE_TIMEOUNT_MINUTES;

  const idleEl = useRef(null);

  const onIdle = () => {
    navigate(`${t("routes.select_service")}`);
  };

  const PATH_PREFIX = i18n.language;

  return (
    <React.Fragment>
      <IdleTimer
        ref={idleEl}
        element={document}
        onIdle={onIdle}
        debounce={250}
        timeout={1000 * 60 * parseFloat(idleMinutes)}
      />
      <Layout />

      <Routes>
        <Route /*pdf:1*/
          path={PATH_PREFIX + t("routes.start_page")}
          element={<StartHarpPage />}
        />
        <Route
          path={PATH_PREFIX + t("routes.pay_heat")}
          element={<PayOwnHeatView />}
        />
        <Route
          path={PATH_PREFIX + t("routes.sns_letter")}
          element={<HeatingLetterFromSNS />}
        />
        <Route
          path={PATH_PREFIX + t("routes.upload_bill_question")}
          element={<HeatingBillQuestion />}
        />
        <Route
          path={PATH_PREFIX + t("routes.household_type")}
          element={<HouseholdTypeHARP />}
        />
        <Route
          path={PATH_PREFIX + t("routes.upload_heating_bill")}
          element={<UploadHeatingBill />}
        />
        <Route
          path={PATH_PREFIX + t("routes.net_income_check")}
          element={<IncomeCheck />}
        />
        <Route
          path={PATH_PREFIX + t("routes.heating_bill_not_needed")}
          element={<HeatingBillProofNotNeeded />}
        />
        <Route
          path={PATH_PREFIX + t("routes.heating_bill_opportunity")}
          element={<HeatingBillOpportunity />}
        />
        <Route
          path={PATH_PREFIX + t("routes.income_assistance")}
          element={<CDSAssistanceQ />}
        />
        <Route
          path={PATH_PREFIX + t("routes.guaranteed_suppliment")}
          element={<GuaranteedIncomeSuppliment />}
        />
        <Route
          path={PATH_PREFIX + t("routes.harp_age_check")}
          element={<AgeCheck />}
        />
        <Route
          path={PATH_PREFIX + t("routes.heat_your_home")}
          element={<HeatingHomeWay />}
        />
        <Route
          path={PATH_PREFIX + t("routes.situation_change")}
          element={<ApplicantSituationChange />}
        />
        <Route
          path={PATH_PREFIX + t("routes.privacy_notice")}
          element={<PrivacyNotice />}
        />
        <Route
          path={PATH_PREFIX + t("routes.personal_information")}
          element={<PersonalInformation />}
        />
        <Route
          path={PATH_PREFIX + t("routes.review_summary")}
          element={<ReviewSummary />}
        />
        <Route
          path={PATH_PREFIX + t("routes.confirmation")}
          element={<Confirmation />}
        />
        <Route
          path={PATH_PREFIX + t("routes.not_eligible")}
          element={<NotEligible />}
        />
        <Route
          path={PATH_PREFIX + t("routes.harp_heat_method")}
          element={<HARPLivingArrangement />}
        />

        <Route
          path={PATH_PREFIX + t("routes.harp_income")}
          element={<HARPIncome />}
        />

        <Route
          path={PATH_PREFIX + t("routes.consent_to_share")}
          element={<ConsentToShareInformation />}
        />
        <Route
          path={PATH_PREFIX + t("routes.check_status")}
          element={<CheckStatus />}
        />
        <Route
          path={PATH_PREFIX + t("routes.application_status")}
          element={<ApplicationStatus />}
        />
        <Route
          path={PATH_PREFIX + t("routes.harp_info_message")}
          element={<HARPStepsMessages />}
        />
        <Route
          path={PATH_PREFIX + t("routes.harp_qualify")}
          element={<HARPQualify />}
        />

        <Route /*pdf:11*/
          path={PATH_PREFIX + t("routes.other_adults_living")}
          element={<OtherAdultsLiving />}
        />

        <Route /*pdf:29*/
          path={PATH_PREFIX + t("routes.without_uploading_bill")}
          element={<WithoutUploadingHeatingProof />}
        />

        <Route /*pdf:25*/
          path={PATH_PREFIX + t("routes.other_adults_form")}
          element={<OtherAdultsForm />}
        />

        <Route
          path={PATH_PREFIX + t("routes.cancel_confirmation")}
          element={<CancelConfirmation />}
        />

        <Route
          path="/"
          element={
            <Navigate replace to={PATH_PREFIX + t("routes.start_page")} />
          }
        />
        <Route
          path={PATH_PREFIX}
          element={
            <Navigate replace to={PATH_PREFIX + t("routes.start_page")} />
          }
        />
        <Route path={"*"} element={<PageNotFound />} />
      </Routes>
      <Footer />
    </React.Fragment>
  );
};

export default withTranslation("common")(OnlineBookingRoutes);
